import React from 'react';
import { View } from 'react-native';
import { LDLAlertCrawl, TWCTimeLogo } from '@components';

import { myWeatherPageTestIDs } from '@constants';

import { styles } from './styles';

export const MyWeatherBottomRow = () => (
  <View style={styles.bottomRowWrapper}>
    <TWCTimeLogo style={styles.logoAndTimeWrapper} testID={myWeatherPageTestIDs.logoAndTimeWidget} />
    <LDLAlertCrawl.API isSevere testID={myWeatherPageTestIDs.alertCrawlWidget} />
  </View>
);
